function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { ButtonBase, Button, Collapse, Grid, Box, List, Typography } from '@applyboard/ui-components';
import { ChevronDownOutlineIcon, ChevronUpOutlineIcon } from '@applyboard/ui-icons';
import { CheckboxListItem } from "./CheckboxListField";
export var CheckboxWithChildren = function CheckboxWithChildren(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    selectedTags = _ref.selectedTags,
    setSelectedTags = _ref.setSelectedTags,
    popularIntakes = _ref.popularIntakes;
  return /*#__PURE__*/React.createElement(Box, {
    pt: 2
  }, options.map(function (option) {
    // open by default if it or any of its children has a true value
    var defaultOpen = value.includes(option.name) || option.children.some(function (child) {
      return value.includes(child.name);
    });
    return /*#__PURE__*/React.createElement(CheckboxSection, {
      key: option.name,
      option: option,
      onChange: onChange,
      value: value,
      defaultOpen: defaultOpen,
      selectedTags: selectedTags,
      setSelectedTags: setSelectedTags,
      popularIntakes: popularIntakes
    });
  }));
};
var CheckboxSection = function CheckboxSection(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    option = _ref2.option,
    defaultOpen = _ref2.defaultOpen,
    selectedTags = _ref2.selectedTags,
    setSelectedTags = _ref2.setSelectedTags,
    popularIntakes = _ref2.popularIntakes;
  var _useState = useState(defaultOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var ariaLabel = "".concat(isOpen ? 'Collapse' : 'Expand', " ").concat(option.label);
  var notCheckedYet = option.children.filter(function (child) {
    return !value.includes(child.name);
  });
  var isAllChecked = notCheckedYet.length === 0 ? true : false;
  var onClickButton = function onClickButton() {
    setIsOpen(!isOpen);
  };
  var setAllSelections = function setAllSelections(checkValue) {
    var newValue = _toConsumableArray(value);
    var updatedTags = selectedTags ? _toConsumableArray(selectedTags) : [];
    option.children.forEach(function (child) {
      if (checkValue) {
        newValue.push(child.name);
      } else {
        newValue = newValue.filter(function (v) {
          return v !== child.name;
        });
      }
      if (selectedTags && popularIntakes) {
        var intakeIsPopular = popularIntakes.some(function (intake) {
          return intake.name === child.name;
        });
        if (intakeIsPopular) {
          if (checkValue && !updatedTags.includes(child.name)) {
            updatedTags.push(child.name);
          } else if (!checkValue) {
            var tagIndex = updatedTags.indexOf(child.name);
            updatedTags.splice(tagIndex, 1);
          }
        }
        setSelectedTags(updatedTags);
      }
    });
    onChange(Array.from(new Set(newValue)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonBase, {
    "aria-label": ariaLabel,
    onClick: onClickButton,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    py: 1,
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    justifyContent: "left",
    textAlign: "left"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "title"
  }, option.label)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      alignItems: 'center'
    }
  }, isOpen ? /*#__PURE__*/React.createElement(ChevronUpOutlineIcon, null) : /*#__PURE__*/React.createElement(ChevronDownOutlineIcon, null)))), /*#__PURE__*/React.createElement(Collapse, {
    "in": isOpen
  }, option.children.length > 1 && /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: function onClick() {
      return setAllSelections(!isAllChecked);
    },
    size: "large",
    variant: "text",
    mt: "1px"
  }, isAllChecked ? 'Clear' : 'Select All'), /*#__PURE__*/React.createElement(List, {
    style: {
      padding: '0 0 16px 8px'
    }
  }, option.children.length > 1 ? /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, option.children.map(function (child) {
    return /*#__PURE__*/React.createElement(Grid, {
      key: "".concat(child.name),
      item: true,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React.createElement(CheckboxListItem, {
      option: child,
      onChange: onChange,
      value: value,
      selectedTags: selectedTags,
      setSelectedTags: setSelectedTags,
      popularIntakes: popularIntakes
    }));
  })) : option.children.length === 1 ? /*#__PURE__*/React.createElement(CheckboxListItem, {
    option: option.children[0],
    onChange: onChange,
    value: value
  }) : /*#__PURE__*/React.createElement(CheckboxListItem, {
    option: option,
    onChange: onChange,
    value: value
  }))));
};